module.exports = __webpack_public_path__ + "media/coffee-preferences/medium_grind-ee962f6f.png";